<template>
	<div class="col-12">
		<input type="hidden" :name="name" :id="id" v-model="message">
		<input type="hidden" name="archivos_adjuntos" value="[]"  id="archivos_adjuntos">
		<trix-editor ref="trix" :input="id" :placeholder="placeholder"></trix-editor>
	</div>
</template>
<script>

import Trix from 'trix';

export default {
	props: ['name', 'id', 'placeholder'],
	data() {
		return {
			archivos_adjuntos: [],
			message: ""
		};
	},
	methods: {
		setMessage(e) {

			this.message = document.getElementById(this.id).value;
		},
		emitDataBackToComponent() {

			this.$emit("dataFromTrix", this.message);
		},
		uploadAttachment(e) {}
	},
	mounted() {

		document.addEventListener("trix-change", this.setMessage);

		function uploadAttachment(attachment) {

			var file = attachment.file;
			var form = new FormData();
			
			form.append('Content-type', file.type);
			form.append('archivos_adjuntos', file);
			var xhr =  new XMLHttpRequest;
			xhr.open('POST', 'administrar-archivos/cargar-adjunto/comunicado', true);
			xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));

			xhr.upload.onprogress = function (event) {

				var progress = event.loaded/event.total * 100;
				attachment.setUploadProgress(progress);

			}

			xhr.onload = function () {

				if (xhr.status === 200) {

					var data = JSON.parse(xhr.responseText);					
				}
			}

			return xhr.send(form);
		}

		function eliminarAdjunto(attachment) {

			var file = attachment.file;
			var form = new FormData();
			
			form.append('Content-type', file.type);
			form.append('archivos_adjuntos', file);
			var xhr =  new XMLHttpRequest;
			xhr.open('POST', 'administrar-archivos/eliminar-adjunto/comunicado', true);
			xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));

			return xhr.send(form);
		}

		document.addEventListener("trix-attachment-add", function(event) {

			const attachment = event.attachment;

			if (attachment.file) {

				const archivosAdjuntos = event.attachment.attachmentManager.managedAttachments
				const nombresDeArchivosAdjuntos = Object.keys(archivosAdjuntos).map(id => archivosAdjuntos[id].attachment.attributes.values.filename);

				const input = document.querySelector('input[name="archivos_adjuntos"]');
				input.value = JSON.stringify(nombresDeArchivosAdjuntos);

				return uploadAttachment(attachment);

			}

		});

		document.addEventListener("trix-attachment-remove", function(event) {

			if (event.attachment.file) {

				return eliminarAdjunto(event.attachment);

			}

			const attributes = event.attachment.getAttributes();
			event.attachment.file = '';

		});

	},
	beforeDestroy: function() {
		document.removeEventListener("trix-change", this.setMessage);
	},
	updated() {
		this.emitDataBackToComponent();
	}	
}
</script>
